import PropTypes from 'prop-types';
import React from 'react';
import ResponsiveTable from '../../Elements/ResponsiveTable/ResponsiveTable';
import EditIcon from '../../Icons/EditIcon/EditIcon';
import ButtonWithChildren from '../../Input/ButtonWithChildren/ButtonWithChildren';

import './EmployerDatabaseResultTable.scss';

// This is a wrapper for the ResponsiveTable component that adds functionality specific to employer research database tables

export default class EmployerDatabaseResultTable extends React.PureComponent {
    constructor(props) {
        super(props);

        this.baseCls = 'component-Employer-EmployerDatabaseResultTable';
    }

    static propTypes = {
        /**
         * array of header objects for table header
         */
        tableHeaders: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string.isRequired,
                sortOptions: PropTypes.arrayOf(
                    PropTypes.shape({
                        label: PropTypes.string,
                        value: PropTypes.oneOf(['asc', 'desc']),
                    })
                ),
                value: PropTypes.string,
            })
        ).isRequired,
        onTipClick: PropTypes.func.isRequired,
        onSort: PropTypes.func.isRequired,
        sortType: PropTypes.string,
        sortOrder: PropTypes.string,
        companyNameIndex: PropTypes.number,
        /**
         * array of row data for table rows
         */
        rowData: PropTypes.arrayOf(PropTypes.array).isRequired,
    };

    static defaultProps = {
        companyNameIndex: 1,
    };

    mapRowData = (row) => {
        const companyId = row[0];
        const companyName = row[this.props.companyNameIndex];
        const output = row.slice(1);
        output.push(
            <ButtonWithChildren
                className={`${this.baseCls}__tip-button`}
                onClick={() => this.props.onTipClick(companyId, companyName)}
            >
                <span className={`${this.baseCls}__tip-text`}>Add a Tip</span>
                <EditIcon />
            </ButtonWithChildren>
        );
        return output;
    };

    render() {
        const {
            baseCls,
            props: { tableHeaders, rowData, sortOrder, sortType, onSort },
        } = this;

        const newRowData = rowData.map(this.mapRowData);
        return (
            <ResponsiveTable
                className={baseCls}
                rowData={newRowData}
                {...{ tableHeaders, sortOrder, sortType, onSort }}
            />
        );
    }
}
